/**
 * Pure gating logic for the meal search input (`MealSelectorSearch`).
 *
 * Kept free of React Native / PowerSync / Apollo runtime deps so it runs under
 * the fast Node `unit` jest project and the debounce + minimum-character gating
 * can be tested as one source of truth (mirrors
 * `lib/local-api/sport-activity/exercise-picker.ts`).
 */

/**
 * Minimum number of (trimmed) characters a query must reach before meal search
 * fires. Below this the request is skipped entirely — server-side fulltext
 * search on one or two characters is wasteful and noisy.
 */
export const MIN_SEARCH_CHARS = 3;

export class MealSearch {
  /**
   * Trim the raw input into the value sent to the server. Returns `undefined`
   * for an empty/whitespace-only string so the query variable is omitted rather
   * than sent as `''`.
   */
  static normalize(raw: string): string | undefined {
    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }

  /**
   * Whether a query should fire for `raw`: true once the trimmed input reaches
   * `minChars`. Surrounding whitespace never counts toward the gate.
   */
  static shouldSearch(raw: string, minChars = MIN_SEARCH_CHARS): boolean {
    return raw.trim().length >= minChars;
  }
}
